import type { Route } from '../shell/routes';

/**
 * The open conversation lives in the URL, so a reload or a shared link lands
 * in it: `#/chat` is a new conversation, `#/chat/<id>` that one.
 */
export function chatRoute(conversationId: string | null): Route {
  return conversationId === null ? { page: 'chat' } : { page: 'chat', action: conversationId };
}

/** The conversation a chat route names, or null for a new one. */
export function conversationIdOf(route: Route): string | null {
  if (route.page !== 'chat' || route.action === undefined) return null;
  const id = route.action.trim();
  return id === '' ? null : id;
}
